import { Link } from "react-router-dom";

const ESPETO_IMG = "https://static.lumi.new/e7/e70f5068f854ad0fcf2e5b0161af0913.png";

interface LogoProps {
  size?: "sm" | "md" | "lg";
  className?: string;
}

function Logo({ size = "md", className = "" }: LogoProps) {
  const sizes = {
    sm: { img: "w-8 h-8", the: "text-lg", job: "text-xl" },
    md: { img: "w-10 h-10", the: "text-xl", job: "text-2xl" },
    lg: { img: "w-14 h-14", the: "text-2xl", job: "text-4xl" }
  };

  const s = sizes[size];

  const textSizes = { sm: "text-xl", md: "text-2xl", lg: "text-4xl" };

  return (
    <Link to="/" className={`flex items-center no-underline group ${className}`} style={{ background: 'none', backgroundColor: 'transparent' }}>
      <span className={`${textSizes[size]} tracking-tight leading-none flex items-center gap-1.5`}>
        <span className="text-[#E53935] font-black">BBQ</span>
        <span className="text-gray-300 font-medium">Jobs</span>
      </span>
    </Link>);

}

export default Logo;